import type { DeliveryTableRow } from 'ui/organisms/DeliveryTable/DeliveryTable.types';

type Translate = (key: string) => string;

export const getDeliveryRows = (t: Translate, bookDemoSlug: string): DeliveryTableRow[] => [
  {
    name: t('Platform'),
    tag: t('No integration'),
    desc: t(
      'Search, verify and export from the web application. Built for analysts running checks one company at a time.',
    ),
    actions: [{ label: t('Start free trial'), route: '/free-trial' }],
  },
  {
    name: 'API',
    tag: 'REST · JSON',
    desc: t(
      'Deterministic endpoints for verification, officers, ownership, financials and screening, plus agentic Regis queries. Both run on one key, priced per result rather than per token.',
    ),
    actions: [{ label: t('Read the docs'), href: 'https://api.globaldatabase.com/docs/v2/#setup' }],
  },
  {
    name: t('Bulk data'),
    tag: 'CSV · S3 · SFTP',
    desc: t(
      'Daily, weekly or monthly registry exports loaded into your own database. Reseller and derivative rights available.',
    ),
    actions: [{ label: t('Talk to sales'), route: bookDemoSlug }],
  },
  {
    name: t('Browser extension'),
    tag: 'Chrome',
    desc: t('Verify a company from any website or LinkedIn profile without leaving the page.'),
    actions: [{ label: t('Add to Chrome'), href: 'https://chromewebstore.google.com/detail/global-database-extension/bjahjijchjnokbgbahdmfcjoblkicank' }],
  },
  {
    name: 'CRM',
    tag: 'Salesforce · HubSpot · Dynamics 365',
    desc: t(
      'Push a shortlist straight into the CRM your deal team already runs, matched on registry number rather than company name. Target records refresh on the same daily sync, so the pipeline carries filed financials and ownership instead of typed notes.',
    ),
    actions: [
      { label: 'Salesforce', href: 'https://appexchange.salesforce.com/appxListingDetail?listingId=7d8cb601-add2-47f7-a345-4008cbb0cfe4' },
      { label: 'HubSpot', href: 'https://ecosystem.hubspot.com/marketplace/listing/global-database-intelligence-enrichment' },
    ],
  },
  {
    name: 'Claude & ChatGPT',
    tag: t('Connector'),
    desc: t(
      'One-click connectors for both assistants. Ask for a company in plain language and get the verified registry record back.',
    ),
    actions: [
      { label: t('Add to Claude'), href: 'https://claude.ai/new#directory/connectors/global-database' },
      { label: t('Add to ChatGPT'), href: 'https://chatgpt.com/plugins/plugin_asdk_app_696f807d21a481918a1ed1f43d719ce9' },
    ],
  },
  {
    name: 'MCP server',
    tag: t('Endpoint'),
    desc: t(
      'Our MCP server exposes the platform as tools to Claude and any other Model Context Protocol client, on the same key and the same provenance fields.',
    ),
    actions: [{ label: t('View setup'), href: '/mcp' }],
  },
  {
    name: 'Regis AI',
    tag: t('In platform · API · Agentic'),
    desc: t(
      'Our own AI model, built into the platform interface and available over the API. Ask a question that spans filings, entities or borders and it plans which registries can answer, calls them, and hands back every value with its registry, reference and timestamp. It cannot answer from training, only from what it retrieved.',
    ),
    actions: [{ label: 'Regis API', href: '/regis-api' }],
  },
];
